import { TooltipProps } from '@elamajs/ui-kit'
import styled, { css } from 'styled-components'

type StyledDotProps = {
  color: string
}

type StyledGraphContainerProps = {
  height?: number
}

type StyledContainerProps = {
  isNoData?: boolean
}

export const Container = styled.div<StyledContainerProps>`
  padding: 20px 10px 10px 25px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 25px;

  width: 100%;

  background-color: ${({ theme, isNoData }) => (isNoData ? '#F9FAFB' : theme.palette.blue[98])};
  border-radius: 10px;

  & .recharts-surface {
    overflow: inherit;
  }

  @media (max-width: 767px) {
    padding: 20px 10px 10px;
  }
`

export const Header = styled.div``

export const Title = styled.h5`
  margin: 0;
  font-family: Navigo, Arial, Helvetica, sans-serif !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  color: #667399 !important;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`

export const Tooltip = styled.div<TooltipProps>`
  color: #667399;

  ~ div > div {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;

    color: #667399;
  }
`

export const GraphContainer = styled.div<StyledGraphContainerProps>`
  ${({ height }) => css`
    height: ${height ? `${height}px` : '100%'};
  `};
`
